// extracted by mini-css-extract-plugin
export default {"moveAnimal":"styles_moveAnimal__lGJgM"};